import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import './Footer.css'

const Footer = () => {
  const baseUrl = "https://api.homehive.co.zw/api"; // API base URL
  const [properties, setProperties] = useState([]);
  useEffect(() => {
    axios.get(`${baseUrl}/properties`)
      .then(response => {
        console.log(response.data)
        setProperties(response.data.results);
      })
      .catch(error => {
        console.error("Error fetching properties:", error);
      });
  }, []);

  return (
    <div>
      <>
        {/*Footer Start*/}
        <footer className="footer bg-style wow fadeInUp">
          <div className="container">
            <div className="footer-upper">
              <div className="row">
                <div className="col-lg-3 col-md-12">
                  <div className="footer-widget about-widget">
                    {" "}
                    <a href="#">
                      {" "}
                      <img style={{backgroundColor: '#fff', padding: '10px', borderRadius: '5px'}} height={100} alt="" src="images/homehive.png" />{" "}
                    </a>
                    <p>
                      Home Hive is your go-to platform for finding the perfect
                      residential properties to buy or rent. 
                    </p>
                  </div>
                </div>
                
                <div className="col-lg-4 col-md-5">
                  <div className="footer-widget contact">
                    <h3 className="title">Recent Properties</h3>
                    <ul className="property_sec">
                    {properties.slice(-2).map((property) => (
                      <li key={property.id}>
                        <div className="rec_proprty">
                          <div className="propertyImg">
                            {property.images && property.images.length > 0 ? (
                              <img style={{ height: '80px' }} src={`${baseUrl}${property.images[0].image}`} alt={property.images[0].image} />
                            ) : (
                              <img style={{ height: '80px' }} src="images/homehive.png" alt="No image available" />
                            )}
                          </div>
                          <div className="property_info">
                            <p className="property_title text-light">
                              <Link className="text-light" to={`/properties/${property.id}`}>{property.property_type_display} ({property.location})</Link>
                            </p>
                            


                            <div className="priceWrp">${property.monthly_rental | property.price_per_night}</div>
                          </div>
                        </div>
                      </li>
                    ))}

                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4">
                  <div className="footer-widget contact">
                    <h3 className="title">Contact Info</h3>
                    <ul className="footer-adress">
                      <li className="footer_email">
                        {" "}
                        <i
                          className="fas fa-envelope"
                          aria-hidden="true"
                        />{" "}
                        <span>
                          <a href="mailto:info@homehive.com">
                            {" "}
                            info@homehive.com{" "}
                          </a>
                        </span>{" "}
                      </li>
                      <li className="footer_phone">
                        {" "}
                        <i className="fas fa-phone-alt" />{" "}
                        <span>
                          <a href="tel:+263776363063"> 776-363-063</a>
                        </span>{" "}
                      </li>
                      <li className="footer_phone">
                        {" "}
                        <i className="fas fa-phone-alt" />{" "}
                        <span>
                          <a href="tel:+263776014002"> 776-014-002</a>
                        </span>{" "}
                      </li>
                    </ul>
                    <div className="social-icons footer_icon">
                      <ul>
                        <li>
                          <a href="#">
                            <i
                              className="fab fa-facebook-f"
                              aria-hidden="true"
                            />
                          </a>
                        </li>
                        <li>
                          <a href="https://www.tiktok.com/@homehive25?_t=ZM-8w9i2YxZf6M&_r=1">
                            <i className="fab fa-tiktok" aria-hidden="true" />
                          </a>
                        </li>
                        <li>
                          <a href="https://www.instagram.com/homehive30?igsh=dDNzcXI4cmR4MWpx">
                            <i
                              className="fab fa-instagram"
                              aria-hidden="true"
                            />
                          </a>
                        </li>

                        <li>
                          <a href="https://wa.me/263774793728?text=Hello%20HomeHive%2C%20I%20am%20interested%20in%20your%20properties">
                            <i
                              className="fab fa-whatsapp"
                              aria-hidden="true"
                            />
                          </a>
                        </li>
                        
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/*Footer End*/}
      </>
    </div>
  );
};

export default Footer;
